/** @format */

import React from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Tooltip} from '@mui/material';

import {FieldLabel} from '../styles';
import {FieldLabelWithHelpProps} from '../../../types';

const FieldLabelWithHelp: React.FC<FieldLabelWithHelpProps> = ({children, tooltipText}) => {
  return (
    <FieldLabel>
      {children}
      <Tooltip title={tooltipText} arrow placement='top'>
        <HelpOutlineIcon sx={{fontSize: 16, color: '#888888'}} />
      </Tooltip>
    </FieldLabel>
  );
};

export default FieldLabelWithHelp;
